const SESSION_TIMEOUT_MINUTES = 30;

const SESSION_TIMEOUT = SESSION_TIMEOUT_MINUTES * 60 * 1000;
const CHECK_INTERVAL = 60 * 1000;
const ACTIVITY_THROTTLE = 30 * 1000;

const LAST_ACTIVITY_KEY = "club_last_activity";
const SESSION_EXPIRED_KEY = "club_session_expired";

let interval = null;
let lastActivitySync = 0;
let onExpireCallback = null;

const now = () => Date.now();

const hasWindow = () => typeof window !== "undefined";

export const updateLastActivity = () => {
  if (!hasWindow()) {
    return;
  }

  const current_time = now();

  if (current_time - lastActivitySync < ACTIVITY_THROTTLE) {
    return;
  }

  lastActivitySync = current_time;
  localStorage.setItem(LAST_ACTIVITY_KEY, String(current_time));
  localStorage.removeItem(SESSION_EXPIRED_KEY);
};

export const resetLastActivity = () => {
  if (!hasWindow()) {
    return;
  }

  const current_time = now();

  lastActivitySync = current_time;
  localStorage.setItem(LAST_ACTIVITY_KEY, String(current_time));
  localStorage.removeItem(SESSION_EXPIRED_KEY);
};

export const clearSessionTimeout = () => {
  if (!hasWindow()) {
    return;
  }

  localStorage.removeItem(LAST_ACTIVITY_KEY);
  localStorage.removeItem(SESSION_EXPIRED_KEY);
};

export const isSessionExpired = () => {
  if (!hasWindow()) {
    return false;
  }

  const last_activity = Number(localStorage.getItem(LAST_ACTIVITY_KEY) || 0);

  if (!last_activity) {
    return false;
  }

  return now() - last_activity >= SESSION_TIMEOUT;
};

export const expireSession = () => {
  if (!hasWindow()) {
    return;
  }

  localStorage.setItem(SESSION_EXPIRED_KEY, String(now()));

  if (typeof onExpireCallback === "function") {
    onExpireCallback();
  }
};

export const validateSessionActivity = () => {
  if (!hasWindow()) {
    return false;
  }

  if (localStorage.getItem(SESSION_EXPIRED_KEY)) {
    expireSession();
    return true;
  }

  if (isSessionExpired()) {
    expireSession();
    return true;
  }

  return false;
};

const handleActivity = () => {
  if (validateSessionActivity()) {
    return;
  }

  updateLastActivity();
};

const handleVisibilityChange = () => {
  if (document.visibilityState === "visible") {
    validateSessionActivity();
  }
};

const handleFocus = () => {
  validateSessionActivity();
};

const handleStorage = (event) => {
  if (
    event.key === SESSION_EXPIRED_KEY &&
    event.newValue &&
    typeof onExpireCallback === "function"
  ) {
    onExpireCallback();
  }
};

export const startSessionTimeout = (callback) => {
  if (!hasWindow()) {
    return;
  }

  stopSessionTimeout();

  onExpireCallback = callback;

  resetLastActivity();

  window.addEventListener("click", handleActivity);
  window.addEventListener("keydown", handleActivity);
  window.addEventListener("scroll", handleActivity);
  window.addEventListener("touchstart", handleActivity);
  window.addEventListener("focus", handleFocus);
  window.addEventListener("storage", handleStorage);
  document.addEventListener("visibilitychange", handleVisibilityChange);

  interval = window.setInterval(() => {
    validateSessionActivity();
  }, CHECK_INTERVAL);
};

export const stopSessionTimeout = () => {
  if (!hasWindow()) {
    return;
  }

  if (interval) {
    window.clearInterval(interval);
    interval = null;
  }

  window.removeEventListener("click", handleActivity);
  window.removeEventListener("keydown", handleActivity);
  window.removeEventListener("scroll", handleActivity);
  window.removeEventListener("touchstart", handleActivity);
  window.removeEventListener("focus", handleFocus);
  window.removeEventListener("storage", handleStorage);
  document.removeEventListener("visibilitychange", handleVisibilityChange);

  onExpireCallback = null;
};
